<template>
  <div class="columns is-mobile is-gapless is-marginless">
    <div class="column is-narrow is-relative">
      <input
        type="checkbox"
        class="is-checkradio is-link is-small"
        :class="{ 'has-background-color': checked }"
        v-model="checked"
        @change="checkOrUncheckChildren"
        :id="id"
      />
      <label class="label-checkbox" :for="id"></label>
    </div>
    <div class="column">
      <label class="layer-name" :for="id">{{ catalog.name }}</label>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    catalog: Object,
    isChecked: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    id() {
      return `cat${this.catalog.id}`;
    },
  },
  data() {
    return {
      checked: this.isChecked,
    };
  },
  methods: {
    checkOrUncheckChildren() {
      const layers = this.catalog.children.map((c) => {
        return { name: c.name, infoSetKeys: null };
      });
      this.$store.dispatch('setLayersVisibility', {
        layers,
        visible: this.checked,
      });
    },
    changeCheked() {
      this.checked = this.isChecked;
    },
  },
  watch: {
    isChecked: {
      handler: 'changeCheked',
      immediate: true,
    },
  },
};
</script>
